/**
 * @flow
 * @relayHash bdbd0138c43a512aff0a00b892b2512f
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type MergeIntoExistingUserInput = {
  userId: string,
  clientMutationId?: ?string,
};
export type MergeIntoExistingUserMutationVariables = {|
  input: MergeIntoExistingUserInput
|};
export type MergeIntoExistingUserMutationResponse = {|
  +mergeIntoExistingUser: ?{|
    +success: boolean
  |}
|};
export type MergeIntoExistingUserMutation = {|
  variables: MergeIntoExistingUserMutationVariables,
  response: MergeIntoExistingUserMutationResponse,
|};
*/


/*
mutation MergeIntoExistingUserMutation(
  $input: MergeIntoExistingUserInput!
) {
  mergeIntoExistingUser(input: $input) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "MergeIntoExistingUserInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "mergeIntoExistingUser",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "MergeIntoExistingUserInput!"
      }
    ],
    "concreteType": "MergeIntoExistingUserPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "success",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "MergeIntoExistingUserMutation",
  "id": null,
  "text": "mutation MergeIntoExistingUserMutation(\n  $input: MergeIntoExistingUserInput!\n) {\n  mergeIntoExistingUser(input: $input) {\n    success\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "MergeIntoExistingUserMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "MergeIntoExistingUserMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'cecbd441c4acbc6b520cdc92edc5d7c4';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/mutations/__generated__/MergeIntoExistingUserMutation.graphql.js